import React, { memo } from "react";
import { observer } from "mobx-react";
import PopupForm from "app/common/Component/Popup/PopupForm";
import { Grid, Tooltip } from "@material-ui/core";
import TableComponent from "app/common/Component/Table/TableComponent";
import { useTranslation } from "react-i18next";
import {
  LAVoucherItemRevenueType,
  TYPE_CARD,
  VOUCHER_INVOICE_TYPE,
  VOUCHER_STATUS,
  VOUCHER_STATUS_VALUE,
  VOUCHER_TYPE_VALUE,
} from "app/common/LocalConst";
import {
  formatMoney,
  formatNumber,
  getDateTime,
} from "app/common/LocalFunction";

function HistoryFeePopup({
  open,
  handleClose,
  searchData,
  pageDataHistory,
  handleChangeFormSearch,
}) {
  const { t } = useTranslation();

  return (
    <PopupForm
      size="xl"
      title="Lịch sử thanh toán"
      open={open}
      handleClose={handleClose}
      formik={{
        initialValues: searchData,
      }}
      hideSubmit
    >
      <Grid container spacing={1}>
        <Grid
          item
          xs={12}
          className="justify-center cards-body pt-0 mt-2"
          style={{
            zIndex: 1,
            position: "relative",
          }}
        >
          <TableComponent
            className=""
            showOrdinalNumbers
            titleNodata={t("noData")}
            data={pageDataHistory?.content}
            name="HistoryFee"
            showMoreButton
            minWidth={"1000"}
            rowCss={(row) =>
              VOUCHER_STATUS.find((el) => el?.value === row?.status)?.className
            }
            columns={[
              {
                field: "code",
                title: "Mã phiếu",
                render: (row) => (
                  <>
                    <b style={{ color: "green" }}>{row?.code}</b>
                    {row?.status === VOUCHER_STATUS_VALUE.Cancel && (
                      <p style={{ color: "RED" }}>
                        <b>ĐÃ HỦY</b>
                      </p>
                    )}
                  </>
                ),
              },

              {
                field: "code",
                title: "Loại",
                render: (row) =>
                  VOUCHER_INVOICE_TYPE?.find(
                    (el) => el?.value === row?.voucherInvoiceType
                  )?.name || "",
              },
              {
                field: "eInvoiceIssuedDate",
                title: t("Trạng thái"),
                render: (row) =>
                  VOUCHER_STATUS?.find((el) => el?.value === row?.status)
                    ?.name || "",
              },
              {
                field: "quantity",
                title: t("Ngày tạo"),
                render: (row) => getDateTime(row?.voucherDate),
              },
              {
                field: "createDate",
                title: t("Thời gian tạo (theo hệ thống)"),
                render: (row) => getDateTime(row?.createDate),
              },
              {
                field: "modifyDate",
                title: t("Thời gian sửa (theo hệ thống)"),
                render: (row) => getDateTime(row?.modifyDate),
              },

              {
                field: "note",
                title: t("Tổng tiền"),
                align: "right",
                render: (row) => <b>{formatMoney(row?.moneyAfterDiscount)}</b>,
              },

              {
                field: "department.name",
                title: t("Cơ sở"),
              },
              {
                field: "note",
                title: t("Chi tiết"),
                render: (row) => {
                  const items = row?.items || [];

                  let htmls = items.map((it, index) => {
                    return (
                      <div class="detail-item">
                        <div className="flex flex-col gap-2 align-start">
                          <Tooltip title="Số tiền thanh toán trong hóa đơn">
                            <span style={{ fontWeight: "bold" }}>
                              <span className="plus">
                                {row.voucherType === -1 ? "-" : "+"}
                              </span>
                              {formatMoney(it?.amount - it?.allocateDiscount)}
                            </span>
                          </Tooltip>
                          <span className="desc" style={{ color: "sienna" }}>
                            {it?.content}
                          </span>
                        </div>
                        {it?.staffRevenues?.length > 0 && (
                          <div className="staff-list">
                            {it.staffRevenues.map((el, ind) => (
                              <div className="staff-item" key={ind}>
                                👤{" "}
                                <span className="revenue-percent">
                                  {el?.sourceName} -{" "}
                                </span>
                                <span className="staff-name">
                                  {el?.staff?.staffName}
                                </span>
                                <span className="percent">
                                  – {formatNumber(el?.percentRevenue)}%
                                </span>
                                <span className="plus">
                                  – {formatMoney(el?.actualAmount)}
                                </span>
                              </div>
                            ))}
                          </div>
                        )}
                        {it?.treatmentPlanCard && (
                          <>
                            <div
                              style={{
                                fontSize: "11px",
                                color: "blue",
                                fontWeight: "bold",
                              }}
                            >
                              <i>
                                <span style={{ textTransform: "capitalize" }}>
                                  {TYPE_CARD.find(
                                    (el) =>
                                      el.value ===
                                      it?.treatmentPlanCard?.clientCard
                                        ?.typeCard
                                  )?.name || ""}
                                </span>
                                :{" "}
                                {it?.treatmentPlanCard?.clientCard?.name || ""}
                              </i>
                            </div>
                          </>
                        )}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            borderBottom: "1px dashed #ccc",
                          }}
                        >
                          {it?.invoiceItem?.subAmountActuallyPaid > 0 && (
                            <div
                              style={{
                                fontSize: "11px",
                              }}
                            >
                              <i>
                                <span>
                                  <Tooltip title="Đã thu">
                                    <b style={{ color: "green" }}>
                                      {row.voucherType ===
                                      VOUCHER_TYPE_VALUE.Paid
                                        ? "-"
                                        : ""}
                                      {formatMoney(
                                        it?.invoiceItem
                                          ?.subTotalBillPatientPaid || 0
                                      )}
                                    </b>
                                  </Tooltip>
                                </span>
                                /
                                <span>
                                  <Tooltip title="Cần thu">
                                    <b style={{ color: "red" }}>
                                      {formatMoney(
                                        it?.invoiceItem?.subAmountActuallyPaid
                                      )}
                                    </b>
                                  </Tooltip>
                                </span>
                              </i>
                            </div>
                          )}
                          <span style={{ fontSize: "12px", color: "#666" }}>
                            <b style={{ marginLeft: 4 }}>
                              {LAVoucherItemRevenueType?.[
                                it.voucherItemRevenueType
                              ]?.name ||
                                Object.values(LAVoucherItemRevenueType).find(
                                  (v) => v.value === it.voucherItemRevenueType
                                )?.name ||
                                "Không rõ"}
                            </b>
                          </span>
                        </div>
                      </div>
                    );
                  });
                  return htmls;
                },
              },

              {
                width: 250,
                title: t("HTTT"),
                render: (row) => {
                  const methods = row.voucherPaymentMethods || [];

                  return (
                    <div>
                      {methods
                        ?.filter((el) => !el?.voided)
                        ?.map((method, index) => {
                          const name = method?.paymentMethodValueName || "";
                          const amount = method?.totalOfMethod ?? 0;
                          const bankAccountNumber =
                            method?.bankAccountNumber || "";
                          const bankName = method?.bankName || "";
                          return (
                            <>
                              <div
                                key={index}
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                <span>
                                  {name && `${name}: `}
                                  <b style={{ color: "green" }}>
                                    {formatMoney(amount)}
                                  </b>
                                </span>
                                {bankName && (
                                  <div>
                                    <span>
                                      <b>{bankName} </b>
                                      {bankAccountNumber && (
                                        <i
                                          style={{
                                            fontSize: "11px",
                                            color: "red",
                                            fontWeight: "500",
                                          }}
                                        >
                                          - {bankAccountNumber}
                                        </i>
                                      )}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </>
                          );
                        })}
                    </div>
                  );
                },
              },
              // {
              //   field: "createdBy",
              //   title: t("Người tạo"),
              // },
              {
                field: "note",
                title: t("Nội dung"),
              },

              {
                field: "accountant.staffName",
                title: t("Thu ngân"),
              },

              {
                field: "createDate",
                title: t("Thời gian thanh toán"),
                render: (row) => getDateTime(row?.voucherDate),
              },

              {
                field: "username",
                title: t("TK thay đổi"),
              },
            ].filter(Boolean)}
            dataPagination={{
              pageIndex: searchData?.pageIndex,
              pageSize: searchData?.pageSize,
              totalElements: pageDataHistory?.totalElements,
              totalPages: pageDataHistory?.totalPages,
              setPageIndex: (pageIndex) =>
                handleChangeFormSearch({ pageIndex }),
              setPageSize: (pageSize) => handleChangeFormSearch({ pageSize }),
            }}
          />
        </Grid>
      </Grid>
    </PopupForm>
  );
}

export default memo(observer(HistoryFeePopup));
